<!--
  登录页面
-->

<template>
  <div class="login">
    <!-- 中间登录弹框 -->
    <div class="login_form">
      <!-- 标题 -->
      <span class="login_title">木棉树污水处理厂大数据平台</span>

      <div class="form">
        <!-- 账号 -->
        <div class="account user_input">
          <img src="@/assets/img/login_account.png" />
          <input type="text" placeholder="请输入用户名" v-model="loginInfo.username" />
        </div>
        <!-- 密码 -->
        <div class="password user_input">
          <img src="@/assets/img/login_password.png" />
          <input type="password" placeholder="请输入密码" v-model="loginInfo.password" />
        </div>
        <!-- 登录按钮 -->
        <div class="login_btn" @click="login()">登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/basic";
export default {
  name: "login",
  data() {
    return {
      // 用户登录信息
      loginInfo: {
        username: "bimadmin",
        password: "123456",
      },
    };
  },
  mounted() {

  },
  methods: {
    // 登录
    login() {
      this.$store.commit("setToken", 'sdfasdfadfadfasf');
      // 将获取token的vuex方法存入session
      sessionStorage.setItem("getToken", 'sdfasdfadfadfasf');
      // 路由跳转
      this.$router.push({ path: "/" });

      return
      if (this.loginInfo.username && this.loginInfo.password) {
        login(this.loginInfo).then((res) => {
          if (res.message == "成功") {
            this.$store.commit("setToken", res.resultdata);
            // 将获取token的vuex方法存入session
            sessionStorage.setItem("getToken", this.$store.getters.getToken);
            // 路由跳转
            this.$router.push({ path: "/" });
          } else {
            alert("输入的账号或者密码有误!!");
          }
        });
      } else {
        alert("请输入账号和密码");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;

  .login_form {
    width: 1879px;
    height: 1666vh * @vh;
    background-image: url("@/assets/img/login_back.png");
    background-size: 100% 100%;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;

    // 标题
    .login_title {
      font-size: 96px;
      position: absolute;
      top: 322vh * @vh;
      left: 200px;
      text-shadow: 1px 1px 15px rgba(105, 214, 254, 1);
    }

    // 输入登录部分
    .form {
      width: 1022px;
      height: 710vh * @vh;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: absolute;
      top: 626vh * @vh;
      left: 415px;

      // 账号密码输入框样式
      .user_input {
        width: 1022px;
        height: 154vh * @vh;
        background: rgba(0, 0, 0, 0.2);
        border: 1px solid #038efa;
        font-size: 42px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        input {
          // background: ;
          height: 100%;
          width: 858px;
          background: rgba(0, 0, 0, 0);
          border: none;
          color: #fff;
          outline: none;
        }

        img {
          margin: 0 55px;
        }
      }

      // 账号
      .account {
        img {
          width: 51px;
        }
      }

      // 密码
      .password {
        img {
          width: 39px;
        }
      }

      // 登录按钮
      .login_btn {
        width: 100%;
        height: 154vh * @vh;
        background: #038efa;
        cursor: pointer;
        line-height: 154vh * @vh;
        font-size: 64px;

        &:active {
          background: #92cef8;
        }
      }
    }
  }
}
@media screen and (min-width: 3640px),screen and(max-height: 1080) {
  .login {

  .login_form {
    width: 1500px;
    height: 1000px;
    // 标题
    .login_title {
      font-size: 80px;
    }

    // 输入登录部分
    .form {
      width: 800px;
      height: 500px;
      top: 350px;
      left: 355px;

      // 账号密码输入框样式
      .user_input {
        width: 800px;
        height: 100px;
        font-size: 52px;

        input {
          // background: ;
          height: 100%;
          width: 858px;
        }

        img {
          margin: 0 55px;
        }
      }

      // 账号
      .account {
        img {
          width: 51px;
        }
      }

      // 密码
      .password {
        img {
          width: 39px;
        }
      }

      // 登录按钮
      .login_btn {
        width: 100%;
        height: 100px;
        line-height: 100px;
        font-size: 54px;
      }
    }
  }
}
}
</style>